﻿import api from '@/api';

export default {
  log(status, error) {
    return api().post(`/error/log`, {
      status,
      error,
    });
  },
};
